module.exports = __webpack_public_path__ + "icon-video-2bec369b38e80e024e4e.svg";